import { RouterProvider } from 'react-router';
import { router } from './router';

export function App() {
  return <RouterProvider router={router} />;
}
